<template>
    <div class="contain" :style="'width:'+(width)+'px;'" v-if="initial!=undefined">
        <div class="imgdiv" :style="'width:'+(width+2)+'px;'">
            <div class="box" :style="'height:'+(height)+'px;'">
                <croppa  ref="myCroppa" v-model="myCroppa" :width="width" :height="height" :zoom-speed="3"
                :disable-scroll-to-zoom="true" @dblclick="changeFile" :canvas-color="'#fff'"
                :prevent-white-space="true" :placeholder="placeholder" :placeholder-font-size="20" :placeholder-color="'#333'"
                :quality="1"  @file-choose="handleCroppaFileChoose" @move="handleCroppaMove"
                :reverse-scroll-to-zoom="true" :file-size-limit="limit" @file-size-exceed="handleCroppaFileSizeExceed"
                @file-type-mismatch="handleCroppaFileTypeMismatch"
                :initial-image="initial" :accept="'image/png,image/jpg,image/jpeg'"
                :show-remove-button="false" @new-image-drawn="handleNewImage"
                ></croppa>
            </div>
            <div class="clickbuttons">
                <img class="bu" @click="changeNum(0)" src="../../assets/images/screenshots/minus.png" alt="">
                <el-slider style="width:75%;margin:0 auto;" v-model="num" :min="0" :max="100"></el-slider>
                <img class="bu" @click="changeNum(1)" src="../../assets/images/screenshots/plus.png" alt="">
            </div>
        </div>
        <div class="imgthumbnail" v-if="isThumbnail">
            <img :src="imgThumbnail" alt="">
        </div>
    </div>
</template>
<script>
import * as api_common from 'service/api/methods/api_common.js';
import i18n from '@/locale/index';

export default {
    components:{
    },
    props:{
        width:{
            type:Number,
            default:320
        },
        height:{
            type:Number,
            default:320
        },
        limit:{
            type:Number,
            default:5120000
        },
        limitMsg:{
            type:String,
            default: i18n.t('Screenshots.index.8003719-0')
        },
        isThumbnail:{
            type:Boolean,
            default:false
        },
        initial:{
            type:String,
            default:undefined
        },
        initialParams:{//初始化参数地址
            type:Object,
            default:()=>{
                return {};
            }
        },
        placeholder: {
            type: String,
            default: i18n.t('Screenshots.index.8003719-1')
        }
    },
    data(){
        return{
            myCroppa:{},
            num:0,
            imgThumbnail:'',//小缩略图地址
            urlpic:this.$constant.fileUploadUrl,
            isUpload:false,//是否更新
        }
    },
    created(){
        this.$nextTick(()=>{
            if(document.getElementsByClassName('el-drawer__body')[0]){
                document.getElementsByClassName('el-drawer__body')[0].scrollTop=0;
            }
        })
    },
    watch:{
        initial(val){
            this.initial=val;
        },
        num(news,old){
            this.isUpload=true;
            let num = news-old;
            if(num>1){
                for (let i = 0; i < num; i++) {
                    this.myCroppa.zoomIn();
                }
            }else if(num==1){
                this.myCroppa.zoomIn();
            }else if(num==-1){
                this.myCroppa.zoomOut();
            }else if(num<-1){
                for (let i = 0; i < Math.abs(num); i++) {
                    this.myCroppa.zoomOut();
                }
            }
            this.isThumbnail  &&  (this.imgThumbnail = this.$refs.myCroppa.generateDataUrl());
        }
    },
    methods:{
        handleCroppaMove(){//文件移动
            this.isThumbnail  &&  (this.imgThumbnail = this.$refs.myCroppa.generateDataUrl());
        },
        changeFile(){//选择文件
            // this.isUpload=true;
            this.$refs.myCroppa.chooseFile();
        },
        handleNewImage(){//图片更换成功
            // console.log("执行handleNewImage");
            this.num=0;
            this.$emit('changeImg',this.initialParams);
        },
        handleCroppaFileChoose(e){//文件选择
            // console.log("执行handleCroppaFileChoose");
            this.isUpload=true;
            if(this.isThumbnail){
                setTimeout(()=>{
                    this.imgThumbnail = this.$refs.myCroppa.generateDataUrl();
                },200)

            }
        },
        changeNum(val){
            if(val==0){
                this.num--;
            }else{
                this.num++;
            }
            if(this.num==-1){
                this.num=0;
                return
            }
            if(this.num==101){
                this.num=100;
                return
            }
        },
        /**
         * type：文件类型：0-新闻封面，1-头像 ，2-培训机构图片（包括许可证、营业执照），3-广告banner 4-课程封面 9-其他
         * name：文件上传的name值固定为：actfile
         * calls：funtion回调方法
         */
        taps(type,name,calls){
            if(this.isUpload){
                this.myCroppa.generateBlob((blob) => {
                    this.uploadAttachment(blob,type,name,calls);
                })
            }else{
                calls(this.initialParams);
            }
        },
        uploadAttachment(blob,type,name,calls){//自定义上传附件
            this.$msg.progressLoad(this.$t('home.home.329132-0'),true,{target:'.el-drawer'});
            let formData = new FormData();
            formData.append(name, blob, "image.png"); //封装到formdata中
            formData.append('type', type);
            // formData.append('name', );
            // formData.append('Authorization', type);
            api_common.uploadFile(formData,false,false).then((res)=>{
                if(res.data){
                    // this.$msg.success("上传成功");
                    calls(res.data);
                }else{
                    this.$msg.alertConfirm(this.$t('Screenshots.index.8003719-2'),this.$t('Screenshots.index.8003719-3'));
                    this.$msg.progressLoad('',false);
                    return
                }
            }).catch((earr)=>{
                this.$msg.progressLoad('',false);
            });
        },
        handleCroppaFileSizeExceed(val){
            this.$msg.alertConfirm(this.limitMsg,this.$t('Screenshots.index.8003719-3'));

        },
        handleCroppaFileTypeMismatch(val){
            this.$msg.alertConfirm(this.$t('Screenshots.index.8003719-4'),this.$t('Screenshots.index.8003719-3'));
        },
        initData(){
            this.num=0;
            // this.myCroppa={};
            this.$refs.myCroppa.remove();
            this.imgThumbnail='';
            this.isUpload=false;//是否更新
        }
    }
}
</script>
<style lang="less" scoped>
@import '~utils/css/general.less';
.contain{
    display: flex;
    align-items: flex-end;
    width:100%;
}
.box{
    border:1px solid rgba(204,204,204,1);
    border-radius: 10px;
    overflow: hidden;
}
.bu{
    // background:rgba(255,255,255,1);
    // border:1px solid rgba(153,153,153,1);
    // color:#999;
    width:20px;
    height: 20px;
    // border-radius: 50%;
    // outline: none;
    cursor: pointer;
}
.clickbuttons{
    display: flex;
    align-items: center;
}
/deep/.el-slider__runway{
    height: 1px !important;
    background:#E3E3E3;
}
/deep/.el-slider__bar{
    height: 1px !important;
    background: #999 !important;
}
/deep/.el-slider__button{
    width:8px;
    height: 8px;
    border:1px solid rgba(153,153,153,1);
}
/deep/.el-slider__button-wrapper{
    top:-17px;
}
.imgthumbnail{
    margin-left:30px;
    width:80px;
    height: 80px;
    margin-bottom:35px;
}
.imgthumbnail img{
    width:100%;
    height: 100%;
}
</style>
